import axios from 'axios';
export default class OtherPlatformService {
    async getOhterPlatformList(data) {
        return await axios .post('api/v1/admin/post-from-other-platform-request/list', data);
    }
    async getprefillIdDetails(id) {
        return await axios .get(`api/v1/admin/post-from-other-platform-request/details/${id}`);
    }
    async viewOtherPost(id) {
        return await axios
            .get(`/api/v1/admin/post-from-other-platform-request/job-details/${id}`)
            .then((res) => res.data);
    }
    async editNotice(data) {
        return await axios
            .post(`api/v1/admin/notice/edit`, data)
            .then((res) => res);
    }
    async saveJob(data) {
        return await axios
            .post(`api/v1/admin/post-from-other-platform-request/add-job`, data)
            .then((res) => res);
    }
    async acceptJob(id) {
        return await axios
            .put(`api/v1/admin/post-from-other-platform-request/request-accept/${id}`)
            .then((res) => res);
    }
    async saveBgImage(data) {
        return await axios
          .post(`api/v1/admin/post-from-other-platform-request/upload-background-image`, data)
          .then((res) => res);
        
      }
      async saveThumnailImage(data) {
        return await axios
          .post(`api/v1/admin/post-from-other-platform-request/upload-thumbnail`, data)
          .then((res) => res);
      }
}
